export default "__VITE_PUBLIC_ASSET__c42085e7__"